// extracted by mini-css-extract-plugin
export default {"container":"ActivityNotificationInfoCircle_container__3CyJS"};